module.exports = __webpack_public_path__ + "img/R06_S2.64019095.jpg";